import { render } from "./VabeneBlogPostsPage.vue?vue&type=template&id=724209cd&ts=true"
import script from "./VabeneBlogPostsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneBlogPostsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__